import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NRTSaleActionBar from "../../../../components/_sale/ActionButtonBar"
import NRTFormStateManager from "../../../../components/_common/_form/FormStateManager"
import NRTFormInput from "../../../../components/_common/_form/FormInput"
import {Validators} from "../../../../components/_common/_form/Validators"
import md5 from 'md5'
import CepRequest from "../../../../requests/cep-request"
import MCSaleFormResponsible from "../../../../components/_sale/FormResponsible"
import MCSaleFormBuyer from "../../../../components/_sale/FormBuyer"
import _ from 'lodash'
import PersonRequests from "../../../../requests/person-requests"
import MCLoadingOverlay from "../../../../components/_minha-central/LoadingOverlay"


const SIMULATE_PERSON_SAVE_ERROR = false
const SIMULATE_PERSON_SEARCH_ERROR = false


class ResponsibleStep extends Component {


    state = {
        awaiting: false,
        paidByCompany: null,
        form: {},
        person: {},
        canProceed: false,
        cpfAlreadyInUse: false,
        firstLoad: true
    }


    lastSearchedResponsibleCep = null
    lastSearchedBuyerCep = null
    lastSearchedBuyerCnpj = null
    lastSearchedCpf = null


    componentDidMount() {
        this.setState({
            newUser: !this.props.context.person,
            person: this.props.context.person,
            canProceed: !!this.props.context.person,
        })
    }


    formChanged = async (form) => {
        this.setState({form})

        if (this.state.firstLoad) {

            this.lastSearchedResponsibleCep = _.get(form, 'values.responsible.addressDTO.cep', null)

            this.setState({
                firstLoad: false
            })
        }

        this.fillResponsibleAddressWithCep(_.get(form, 'values.responsible.addressDTO.cep', null))
        this.fillBuyerAddressWithCep(_.get(form, 'values.buyer.addressDTO.cep', null))

        this.fillBuyerInfoWithCNPJ(_.get(form, 'values.buyer.cpfCnpj', null))

        const cpf = _.get(form, 'values.responsible.cpfCnpj')
        if (!Validators.cpf()(cpf)) {
            if (this.state.newUser && this.lastSearchedCpf !== cpf) {
                this.lastSearchedCpf = cpf
                const cpfAlreadyInUse = await this.isCpfAlreadyInUse(cpf)
                this.setState({
                    canProceed: !cpfAlreadyInUse,
                    cpfAlreadyInUse
                })
            }
        }


    }


    fillBuyerInfoWithCNPJ(cnpj) {
        if (this.lastSearchedBuyerCnpj === cnpj)
            return
        if (!cnpj || Validators.cnpj()(cnpj))
            return

        this.lastSearchedBuyerCnpj = cnpj

        const req = SIMULATE_PERSON_SEARCH_ERROR ?
            Promise.reject() : PersonRequests.search({cpfCnpj: cnpj}, true)

        req
            .then(person => this.refs.formBuyer.updatePayerInfo(person))
            .catch(err => {
                console.error(err)
                this.props.context.set({
                    toastMessage: {
                        type: 'error',
                        content: 'Desculpe, houve um erro ao buscar as informações da empresa.'
                    }
                })
            })

    }


    fillBuyerAddressWithCep(cep) {
        if (cep === this.lastSearchedBuyerCep)
            return

        this.lastSearchedBuyerCep = cep
        this.fillAddressWithCep(cep, false)
    }


    fillResponsibleAddressWithCep(cep) {
        if (cep === this.lastSearchedResponsibleCep)
            return

        this.lastSearchedResponsibleCep = cep
        this.fillAddressWithCep(cep)
    }


    fillAddressWithCep(cep, isResponsibleCep = true) {

        CepRequest.search(cep)
            .then(result => {

                if (!result)
                    return

                if (isResponsibleCep && this.refs.formResponsible) {
                    this.refs.formResponsible.updateAddress(result)
                } else if (this.refs.formBuyer) {
                    this.refs.formBuyer.updateAddress(result)
                }

            })
    }


    submit = () => {

        if (
            !this.state.canProceed ||
            this.state.awaiting ||
            this.state.form.dirty === false
        )
            return

        this.form.validate(async () => {

            if (!this.state.form.valid)
                return null

            const {context} = this.props
            const {schema} = context.credentials
            const {person} = context

            const isNewUser = !person

            const {
                form,
                paidByCompany
            } = this.state


            let responsibleDto = null

            if (isNewUser) {

                const cpf = form.values.responsible.cpfCnpj

                responsibleDto = {
                    ...form.values.responsible,
                    password: md5(form.values.responsible.password),
                    login: `${schema}.${cpf}`,
                    type: 2

                }


            } else {
                responsibleDto = {
                    ...person,
                    ...form.values.responsible,

                    cpfCnpj: person.cpfCnpj,
                    password: person.password,
                    login: person.login,

                }

            }
            console.debug('PROPS', this.props)
            console.debug('CONTEXT', context)

            if (_.isEmpty(responsibleDto['tagDTOList'])) {
                responsibleDto['tagDTOList'] = []
            }
            responsibleDto['tagDTOList'].push({
                name: context.saleRelease.product.name,
                tggCode: 1,
            })

            delete responsibleDto['confirmPassword']



            this.setState({awaiting: true})

            if (paidByCompany) {

                try {

                    const buyerDto = {
                        ...form.values.buyer,
                        type: 2,
                        legal: true
                    }

                    if (buyerDto.code === '')
                        delete buyerDto['code']

                    if (buyerDto.login === '')
                        buyerDto.login = `${schema}.${buyerDto.cpfCnpj}`


                    const buyer = await PersonRequests.save(buyerDto, true)

                    if (buyer.errorMessages.length > 0 )
                        return this.onSavePersonError(buyer.errorMessages[0])


                    const responsible = await PersonRequests.save(responsibleDto, true)

                    if (responsible.errorMessages.length > 0 )
                        return this.onSavePersonError(responsible.errorMessages[0])

                    context.set({
                        person: responsible,
                        saleResponsible: responsible,
                        saleBuyer: buyer,

                    }, () => {
                        this.props.goToNextStep()
                    })

                } catch (e) {

                    console.error(e)
                    this.setState({awaiting: false})
                    context.set({
                        toastMessage: {
                            type: 'error',
                            content: 'Desculpe, ocorreu um erro inesperado.'
                        }
                    })
                }

            } else {

                try {

                    const responsible = await PersonRequests.save(responsibleDto, true)

                    if (responsible.errorMessages.length > 0 )
                        return this.onSavePersonError(responsible.errorMessages[0])


                    context.set({
                        person: responsible,
                        saleResponsible: responsible,
                        saleBuyer: responsible,

                    }, () => {
                        this.props.goToNextStep()
                    })

                } catch (e) {


                    console.error(e)
                    this.setState({awaiting: false})
                    context.set({
                        toastMessage: {
                            type: 'error',
                            content: 'Desculpe, ocorreu um erro inesperado.'
                        }
                    })
                }

            }
        })


    }

    onSavePersonError(errorMessage) {
       // console.error(errorMessage)
        this.setState({awaiting: false})
        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: errorMessage
            }
        })
    }



    submitDebounced = _.debounce(this.submit, 300)


    isCpfAlreadyInUse = async (cpf) => {
        try {


            const foundPerson = await PersonRequests.search({cpfCnpj: cpf}, true)

            return !!_.get(foundPerson, 'code')

        } catch (err) {
            console.error(err)
            return true
        }

    }


    render() {

        if (this.form)
            this.form.validate()

        const {
            awaiting,
            cpfAlreadyInUse,
        } = this.state
        const person = this.state.person

        return (
            <div className={'nrt-responsible-step'}>

                <MCLoadingOverlay show={awaiting}/>
                <NRTFormStateManager
                    onStateChange={this.formChanged}
                    ref={(f) => this.form = f}>

                    <MCSaleFormResponsible
                        cpfAlreadyInUse={cpfAlreadyInUse}
                        ref={'formResponsible'}
                        person={person}
                    />

                    {
                        ! _.get(person , 'legal') &&
                        <React.Fragment>
                            <div className={'paid-by-company-container'}>

                                <NRTFormInput
                                    label={'Esta compra será faturada por uma empresa? *'}
                                    onChange={(name, value) => this.setState({paidByCompany: value})}
                                    value={this.state.paidByCompany}
                                    type={'radiogroup'}
                                    style={{
                                        textAlign: 'center'
                                    }}
                                    customProps={{
                                        options: [
                                            {
                                                value: true,
                                                display: 'Sim'
                                            },
                                            {
                                                value: false,
                                                display: 'Não'

                                            }
                                        ],
                                        style: {
                                            justifyContent: 'center',
                                            display: 'flex',
                                        }
                                    }}
                                    validators={[
                                        (value) => {
                                            if (value === null)
                                                return 'Este campo é obrigatório.'
                                        }
                                    ]}
                                />
                            </div>

                            {
                                this.state.paidByCompany &&
                                <MCSaleFormBuyer ref={'formBuyer'}/>
                            }
                        </React.Fragment>
                    }


                    <NRTSaleActionBar onClick={this.submitDebounced}
                                      disabled={!this.state.form.valid || !this.state.canProceed}
                                      loading={awaiting}
                    />
                </NRTFormStateManager>
            </div>
        )
    }
}


ResponsibleStep.propTypes = {
    goToNextStep: PropTypes.func.isRequired,
    context: PropTypes.object.isRequired,
}
ResponsibleStep.defaultProps = {}


export default ResponsibleStep



// WEBPACK FOOTER //
// ./src/_pages/Sale/_partials/ResponsibleStep/index.js